import { render, staticRenderFns } from "./ImagemComFallback.vue?vue&type=template&id=2d98a2b1"
import script from "./ImagemComFallback.vue?vue&type=script&lang=js"
export * from "./ImagemComFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports